import SmallBadge from "@/common/components/SmallBadge";
import { formatCurrency } from "@/common/utils/formatters";
import { AuctionProposalLeadValueProps } from "@/features/maintenance/features/establishmentChoice/features/auctions/types/auctionProposalLeadValue.type";

const ExecutionProposalLeadValue = ({ proposal, tooltipId }: AuctionProposalLeadValueProps) => {
  const totalValue = proposal.contents?.total_value;

  if (totalValue == null)
    return null;

  return (
    <SmallBadge
      data-tooltip-id={tooltipId}
      data-tooltip-content="Valor total"
      text={`${formatCurrency(Number(totalValue))} Total`}
      className="bg-success-op text-success-tertiary"
    />
  );
}

export default ExecutionProposalLeadValue;
